// Grab elements
const shippingCountry = document.getElementById("AddressCountry_Shipping");
const countryState = document.getElementById("AddressProvince_shipping");
const shippingCountryZip = document.getElementById("ShippingAddressZip");
const shippingRatePackage = document.querySelector(".shipping_rate_package");
const shippingAddressWrapper = document.querySelector(".shipping_rate_message");
const shippingAddressCount = document.querySelector(".shipping_address_count");
const item = document.querySelector(".shipping_calc_save");

// If the shipping calculator UI is not on this page, do nothing.
// This prevents cart (and other pages) from crashing.
if (
  !shippingCountry ||
  !countryState ||
  !shippingCountryZip ||
  !shippingRatePackage ||
  !shippingAddressWrapper ||
  !shippingAddressCount ||
  !item
) {
  // Optional: uncomment for debugging
  // console.log("[shipping_calculator] UI not present, skipping init");
} else {
  // Only init country/province selector if the elements exist
  if (window.Shopify && Shopify.CountryProvinceSelector) {
    new Shopify.CountryProvinceSelector(
      "AddressCountry_Shipping",
      "AddressProvince_shipping",
      { hideElement: "AddressProvinceContainerNewShiping" }
    );
  }

  item.addEventListener("click", () => {
    shippingRatePackage.innerHTML = "";

    if (shippingCountry.value !== "---") {
      item.classList.add("loading");

      const url =
        `/cart/shipping_rates.json?` +
        `shipping_address%5Bzip%5D=${encodeURIComponent(shippingCountryZip.value)}` +
        `&shipping_address%5Bcountry%5D=${encodeURIComponent(shippingCountry.value)}` +
        `&shipping_address%5Bprovince%5D=${encodeURIComponent(countryState.value)}`;

      fetch(url)
        .then((response) => {
          if (response.ok) return response.json();
          throw window?.shipping?.wrong_message || "Unable to fetch shipping rates.";
        })
        .then((response) => {
          item.classList.remove("loading");

          shippingAddressWrapper.classList.remove("no-js-inline");
          shippingAddressCount.innerText = `${response.shipping_rates.length}`;

          response.shipping_rates.forEach((rate) => {
            const p = document.createElement("p");
            p.className = "mb-0";
            p.innerText = `${rate.name}: ${shopCurrencySymbol}${rate.price}`;
            shippingRatePackage.appendChild(p);
          });
        })
        .catch((e) => {
          item.classList.remove("loading");
          shippingAddressWrapper.classList.add("no-js-inline");
          shippingRatePackage.innerHTML = `<p class="error mt-15">${e}</p>`;
        });
    } else {
      shippingAddressWrapper.classList.add("no-js-inline");
      shippingRatePackage.innerHTML = `<p class="error mt-15">${
        window?.shipping?.country_label || "Please select a country."
      }</p>`;
    }
  });
}
